import * as React from "react";
import dynamic from "next/dynamic";
import { Formik } from "formik";
import { Button, Card, CardContent, Grid } from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { ErrorCommon, Label, PhoneNumberField, TextField, TextFieldCommon } from "./formikFormInputs";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import TextEditor from "./Editor";
import axios from "axios";
import { carrierId, showEditIconBlue, stagingServerUrl } from "../server/constants";
import {
  required,
  email,
  phoneNumber
} from "../utils/validation";
import { unmaskPhoneNumber } from "../utils/commonUtils";
import { AlertMessage } from './Common';

const useStyles = makeStyles((theme) =>
  createStyles({
    getStarted: {
      textAlign: 'center',
      position: 'relative',
      overflow: 'visible',
      float: 'left',
      width: '100%',
      '&::before': {
        content: '" "',
        position: 'absolute',
        width: 0,
        height: 0,
        borderTop: '20px solid transparent',
        borderRight: '28px solid #ffffff',
        borderBottom: '20px solid transparent',
        left: -24,
        top: '44%',

        [ theme.breakpoints.down("sm") ]: {
          top: '-21px',
          left: '42%',
          right: '0',
          borderTop: '0',
          borderLeft: '15px solid transparent',
          borderRight: '15px solid transparent',
          borderBottom: '22px solid #FFFFFF',
        },
      },
    },
  }),{
    name: "TouchWithSpecialistStyle"
  }
);


function TouchWithSpecialist(props: { strategyText: any, strategyDescendantText: any, strategyName: string, parentStrategy: number }) {
  const classes = useStyles();
  const [snackbarOpen, setSnackbarOpen] = React.useState(true);
  const [message, setMessage] = React.useState("");
  const [severity, setSeverity] = React.useState<string | any>("success");

  const contactType = "NEXT_2_BUSINESS_DAY";
  const {
    strategyText,
    strategyDescendantText,
    strategyName,
    parentStrategy
  } = props;
  const fieldObj = [{
    id: "firstNameLastName",
    name: "firstNameLastName",
    component: TextField,
    validate: required,
    placeholder: "First & Last Name",
    label: <Label label={"First & Last Name"} required={true}/>,
    rowSize: 6
  }, {
    id: "phone",
    name: "phone",
    component: PhoneNumberField,
    placeholder: "Phone",
    validate: phoneNumber,
    label: <Label label={"Phone"} required={true}/>,
    rowSize: 6
  }, {
    id: "email",
    name: "email",
    component: TextField,
    placeholder: "Email",
    validate: email,
    label: <Label label={"Email"} required={true}/>,
    rowSize: 12
  },
    {
      id: "message",
      name: "message",
      component: TextField,
      multiline: true,
      rows: 6,
      placeholder: "Optional Message",
      label: <Label label={"Optional Message"}/>,
      rowSize: 12,
    }
  ];
  const submitFormik = async (values: any, resetForm: any) => {
    let firstName: string;
    let lastName: string = "";
    let firstNameLastName: string = values.firstNameLastName;
    let firstNameLastNameArray: Array<string> = firstNameLastName.split(" ");
    if (firstNameLastNameArray.length > 1) {
      firstName = firstNameLastNameArray[ 0 ];
      lastName = firstNameLastNameArray[ 1 ];
    } else {
      firstName = values.firstNameLastName;
    }
    let payload: any = {
      "firstName": firstName,
      "lastName": lastName,
      "email": values.email,
      "phone": unmaskPhoneNumber(values.phone),
      "age": 30,
      "strategyId": parentStrategy || 1,
      "strategyLabel": strategyName,
      "gender": 1,
      "contribution": 0,
      //"householdIncome": 100000,
      "healthType": "Standard",
      "contactType": contactType,
      "specificDate": null,
      "specificTime": null,
      "leadSource": "niwcorp.com",
      "carrierId": carrierId,
      "agentLinkId": 0
    };
    if (contactType === "NEXT_2_BUSINESS_DAY") {
      delete payload.specificDate;
      delete payload.specificTime;
    }

    await axios.post(`${stagingServerUrl}/leads`, payload, {}).then((response: any) => {
      if (response) {
        setMessage("Thanks for your request an agent will contact you shortly.");
        setSeverity("success");
        setSnackbarOpen(true);
      }
      resetForm();
    }).catch((error: any) => {
      setMessage(error && error.response && error.response.data && error.response.data.message);
      setSeverity("error");
      setSnackbarOpen(true);
    });
  };

  const intitialValues = {
    firstNameLastName: "",
    phone: "",
    email: "",
    message: ""
  };

  return (
    <Card className={classes.getStarted}>
      <CardContent>
          <AlertMessage
            message={message}
            open={snackbarOpen}
            severity={severity}
            setOpen={setSnackbarOpen} />

          <TextEditor component="strong" color="primary"
                      sectionId={"strategyText"}
                      content={strategyText}
                      upperDivClass={showEditIconBlue}
          />
        <br/>
          <TextEditor variant="" className="textLightBlack mb20 mt20"
                      sectionId={"strategyDescendantText"}
                      content={strategyDescendantText}
                      upperDivClass={showEditIconBlue}
          />
        <Formik
          initialValues={intitialValues}
          onSubmit={(values: any, {resetForm}: any) => submitFormik(values, resetForm)}
        >
          {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }: any) =>
            (

              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  {
                    fieldObj.map((field, index) => {
                      return (
                        <Grid item xs={field.rowSize === 12 ? 12 : field.rowSize === 12 ? 12 : 12}
                              sm={field.rowSize === 12 ? 12 : field.rowSize === 6 ? 6 : 6} key={index}>
                          <TextFieldCommon
                            {...field}
                            values={values}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorCommon errors={errors} name={field.name} touched={touched}/>
                        </Grid>)
                    })
                  }
                </Grid>

                <Button
                  size="small"
                  className="mt20 floatRight mb20"
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={(isSubmitting || Object.keys(errors).length > 0)}
                  endIcon={<ArrowForwardIcon/>}
                >
                  Get in Touch
                </Button>
              </form>
            )
          }
        </Formik>
      </CardContent>
    </Card>
  )
}

export default dynamic(() => Promise.resolve(TouchWithSpecialist), {
  ssr: false
})
